<div class="container-fluid-modal">
 <form #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>

  <!-- <form #user="ngForm" (ngSubmit)="submitForm(user.value)" class="form-inline required" novalidate> -->
    <div *ngIf="formShow === 'add'" class="add">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Add User</h4>
        <div class="headerButton">
          <button [disabled]="" class="btn btn-success" type="submit"><i aria-hidden="true" class="fa fa-floppy-o"></i>
            Save
          </button>
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Close
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="card">
            <mat-tab-group animationDuration="0ms" class="col-lg-12">
            <mat-tab label="User Information">
              <table class="table">
                <tbody>
                  <tr class="">
                    <td colspan=2>

            <div class="form-group col-lg-12">
              <label class="labelRequired">Location </label>
              <select [(ngModel)]="formData.location_id" class="form-control"
                      data-show-content="true" name="location_id" placeholder="Select the Roles" #location_id="ngModel"[ngClass]= "{'has-danger': cat?.submitted  && location_id?.invalid }" required>
                      <div *ngIf="cat?.submitted  && location_id?.invalid ">
                <div [hidden]="!location_id.errors.required" class="formError"> * Location is required </div>
                 </div>
                <option disabled>Select the Location</option>
                <option *ngFor="let data of locationData" [value]="data?.id">
                  {{data?.name}}
                </option>
              </select>
            </div>
            <div class="form-group col-lg-12">
              <label class="labelRequired">Roles </label> 
              <select [(ngModel)]="formData.role_id" class="form-control"
                      data-show-content="true" name="role_id" placeholder="Select the Roles"#role_id="ngModel"[ngClass]= "{'has-danger': cat?.submitted  && role_id?.invalid }" required>
                      <div *ngIf="cat?.submitted  && role_id?.invalid ">
                <div [hidden]="!role_id.errors.required" class="formError"> * Role is required </div>
                 </div>
                <option disabled>Select the Roles</option>
                <option *ngFor="let data of rolesData" [value]="data?.id">
                  {{data?.name}}
                </option>
              </select>
             </div> 


            <div class="form-group col-lg-12">
              <label class="labelRequired">First Name </label>
              <input [(ngModel)]="formData.first_name" class="form-control" name="first_name"
              #first_name="ngModel"required  placeholder="First Name" required type="text"[ngClass]= "{'has-danger': cat?.submitted  && first_name?.invalid }">
               <div *ngIf="cat?.submitted  && first_name?.invalid ">
                <div [hidden]="!first_name.errors.required" class="formError"> * First Name is required </div>
                 </div>
            </div>

            <div class="form-group col-lg-12">
              <label class="labelRequired">Last Name </label>
                <input [(ngModel)]="formData.last_name" class="form-control" name="last_name"
              #last_name="ngModel"required  placeholder="Last Name" required type="text"[ngClass]= "{'has-danger': cat?.submitted  && last_name?.invalid }">
               <div *ngIf="cat?.submitted  && last_name?.invalid ">
                <div [hidden]="!last_name.errors.required" class="formError"> * Last Name is required </div>
                 </div>
            </div>

            <div class="form-group col-lg-12">
              <label class="labelRequired">Email </label>
              <input [(ngModel)]="formData.email" class="form-control" name="email"
              #email="ngModel"required  placeholder="Email" required type="text"[ngClass]= "{'has-danger': cat?.submitted  && email?.invalid }">
               <div *ngIf="cat?.submitted  && email?.invalid ">
                <div [hidden]="!email.errors.required" class="formError"> * Email is required </div>
                 </div>
            </div>
            <div class="form-group col-lg-12">
              <label class="labelRequired">Username </label>
              <input [(ngModel)]="formData.username" class="form-control" name="username"
              #username="ngModel"required  placeholder="Username" required type="text"[ngClass]= "{'has-danger': cat?.submitted  && username?.invalid }">
               <div *ngIf="cat?.submitted  && username?.invalid ">
                <div [hidden]="!username.errors.required" class="formError"> * Username is required </div>
                 </div>
            </div>


             </td></tr> </tbody>
                  </table>
             </mat-tab>

           <mat-tab label="Notification">
                    <table class="table">
                      <tbody>
                  <tr rowspan=""
                    class="col-lg-12">
                   
                        <td>
                        Re-Order </td>
                        <td>  <input [(ngModel)]="formData.Sale_Reorder_Notification"   class="form-control"   name="Sale_Reorder_Notification" type="checkbox" value="" > </td>
                      </tr>
                     <tr rowspan=""
                    class="col-lg-12">

                        <td >
                        Sales Order 
                        </td>
                        <td>  <input   [(ngModel)]="formData.Sale_Order_Notification"  class="form-control"   name="Sale_Order_Notification" type="checkbox" value="" > </td>
                      </tr>
                     <tr rowspan=""
                    class="col-lg-12">

                        <td >
                        Sales Invoice 
                        </td><td>
                         <input   [(ngModel)]="formData.Sale_Invoice_Notification"  class="form-control"   name="Sale_Invoice_Notification" type="checkbox" value="" > </td>
                      </tr>
                     <tr rowspan=""
                    class="col-lg-12">

                        <td>
                        Stock Movement 
                        </td>
                        <td>  <input  [(ngModel)]="formData.Implants_Movement_Notification"  class="form-control"   name="Implants_Movement_Notification" type="checkbox" value="" > </td>
                      </tr>
                    <tr rowspan=""
                    class="col-lg-12">

                        <td>
                        Used Implants 
                        </td>
                        <td>  <input    class="form-control" [(ngModel)]="formData.Implants_Consumed_Notification"  name="Implants_Consumed_Notification" type="checkbox" value="" > </td>
                      </tr>
                    <tr rowspan=""
                    class="col-lg-12">

                        <td >
                        Rejected Impants 
                        </td>
                        <td>  <input    class="form-control"  [(ngModel)]="formData.Implants_Rejected_Notification"  name="Implants_Consumed_Notification" type="checkbox" value="" > </td>


          
                      </tr>


                    </tbody>
                  </table>
             </mat-tab>



            </mat-tab-group>
         </div>
       
      </mat-dialog-content>
    </div>

    <div *ngIf="formShow === 'edit'" class="edit">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Edit User</h4>
        <div class="headerButton">
          <button *ngIf="editPermission" class="btn btn-success" type="submit"><i aria-hidden="true" class="fa fa-floppy-o"></i> Save
          </button>
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Cancel
          </button>
        </div>
      </div>

      <mat-dialog-content>
        <div class="card">

              <mat-tab-group animationDuration="0ms" class="col-lg-12">
            <mat-tab label="User Information">
              <table class="table col-lg-12">
                <tbody>
                  <tr class="">
                    <td>
             <div class="form-group col-lg-12">
              <label class="labelRequired">Location </label>
              <select [(ngModel)]="editData.user.location_id" class="form-control"
                      data-show-content="true" name="location_id" placeholder="Select the Roles"
                      required>
                <option disabled>Select the Location</option>
                <option *ngFor="let data of locationData" [value]="data?.id">
                  {{data?.name}}
                </option>
              </select>
            </div>
            <div class="form-group col-lg-12">
              <label class="labelRequired">Roles </label>
              <select [(ngModel)]="editData.user.role_id" class="form-control"
                      data-show-content="true" name="role_id" placeholder="Select the Roles"
                      required>
                <option disabled>Select Roles</option>
                <option *ngFor="let data of rolesData" [value]="data?.id">
                  {{data?.name}}
                </option>
              </select>
            </div>

            <div class="form-group col-lg-12">
              <label class="labelRequired">First Name </label>
              <input [(ngModel)]="editData.user.first_name" class="form-control" name="first_name"
                     placeholder="First Name" required #first_name="ngModel" type="text"[ngClass]= "{'has-danger': cat?.submitted  && first_name?.invalid }">
               <div *ngIf="cat?.submitted  && first_name?.invalid ">
                <div [hidden]="!first_name.errors.required" class="formError"> * First Name is required </div>
                 </div>
            </div>

            <div class="form-group col-lg-12">
              <label class="labelRequired">Last Name </label>
              <input class="form-control" name="last_name" [(ngModel)]="editData.user.last_name" placeholder="Last Name"#last_name="ngModel"required type="text"[ngClass]= "{'has-danger': cat?.submitted  && last_name?.invalid }">
               <div *ngIf="cat?.submitted  && last_name?.invalid ">
                <div [hidden]="!last_name.errors.required" class="formError"> * Last Name is required </div>
                 </div>
            </div>
                   
           
            <div class="form-group col-lg-12">
              <label class="labelRequired">Email </label>
              <input class="form-control" name="email" [(ngModel)]="editData.user.email" placeholder="Email"
                     required type="email" #email="ngModel"required type="text"[ngClass]= "{'has-danger': cat?.submitted  && email?.invalid }">
               <div *ngIf="cat?.submitted  && email?.invalid ">
                <div [hidden]="!email.errors.required" class="formError"> * Email is required </div>

                <!-- <div [hidden]="!email.errors.required" class="formError"> * Email must be a valid  </div> -->

                 </div>
            </div>
            <div class="form-group col-lg-12">
              <label class="labelRequired">Username </label>
              <input class="form-control" name="username" [(ngModel)]="editData.user.username" placeholder="Username"#username="ngModel"required   required type="text"[ngClass]= "{'has-danger': cat?.submitted  && username?.invalid }">
               <div *ngIf="cat?.submitted  && username?.invalid ">
                <div [hidden]="!username.errors.required" class="formError"> * Username is required </div>
                 </div>
            </div>
            </td></tr> </tbody>
                  </table>
             </mat-tab>
      <mat-tab label="Notification">
                    <table class="table">
                      <tbody>
                  <tr rowspan=""
                    class="col-lg-12">

                       <td>
                        Re-Order </td>
                        <td>  <input [(ngModel)]="formData.Sale_Reorder_Notification"   class="form-control"   name="Sale_Reorder_Notification" type="checkbox" value="" > </td>
                      </tr>
                     <tr rowspan=""
                    class="col-lg-12">

                        <td >
                        Sales Order 
                        </td>
                        <td>  <input   [(ngModel)]="formData.Sale_Order_Notification"  class="form-control"   name="Sale_Order_Notification" type="checkbox" value="" > </td>
                      </tr>
                     <tr rowspan=""
                    class="col-lg-12">

                        <td >
                        Sales Invoice 
                        </td><td>
                         <input   [(ngModel)]="formData.Sale_Invoice_Notification"  class="form-control"   name="Sale_Invoice_Notification" type="checkbox" value="" > </td>
                      </tr>
                     <tr rowspan=""
                    class="col-lg-12">

                        <td>
                        Stock Movement 
                        </td>
                        <td>  <input  [(ngModel)]="formData.Implants_Movement_Notification"  class="form-control"   name="Implants_Movement_Notification" type="checkbox" value="" > </td>
                      </tr>
                    <tr rowspan=""
                    class="col-lg-12">

                        <td>
                        Used Implants 
                        </td>
                        <td>  <input    class="form-control" [(ngModel)]="formData.Implants_Consumed_Notification"  name="Implants_Consumed_Notification" type="checkbox" value="" > </td>
                      </tr>
                    <tr rowspan=""
                    class="col-lg-12">

                        <td >
                        Rejected Impants 
                        </td>
                        <td>  <input    class="form-control"  [(ngModel)]="formData.Implants_Rejected_Notification"  name="Implants_Rejected_Notification" type="checkbox" value="" > </td>
          
                      </tr>


                    </tbody>
                  </table>
             </mat-tab>
            </mat-tab-group>
        </div>
      </mat-dialog-content>
    </div>



    <div *ngIf="formShow === 'password'" class="update">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Update Password</h4>
        <div class="headerButton">
          <button *ngIf="editPermission" class="btn btn-success" type="submit"><i aria-hidden="true" class="fa fa-floppy-o"></i> Save
          </button>
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Cancel
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="form-group col-lg-12">
              <label class="labelRequired">Password </label>
              <input class="form-control" name="password" value="" [(ngModel)]="editData.user.password" placeholder="Password" required type="password"
              #password="ngModel"[ngClass]= "{'has-danger': cat?.submitted  && password?.invalid }">
               <div *ngIf="cat?.submitted  && password?.invalid ">
                <div [hidden]="!password.errors.required" class="formError"> * Password is required </div>
                 </div>
            </div>
            <div class="form-group col-lg-12">
              <label class="labelRequired">Confirmation Password</label>
              <input class="form-control" name="password_confirmation" value="" [(ngModel)]="editData.user.password_confirmation" #password_confirmation="ngModel"required  placeholder="Password"  type="password"[ngClass]= "{'has-danger': cat?.submitted  && password_confirmation?.invalid }">
               <div *ngIf="cat?.submitted  && password_confirmation?.invalid ">
                <div [hidden]="!password_confirmation.errors.required" class="formError"> * Password is required </div>
                 </div>
                     
            </div>
          </div>
        </div>
      </mat-dialog-content>
    </div>
  </form>
</div>
